import { Component, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { AuthService, MaintenanceService } from '../services';
import { Storage } from '@ionic/storage';
import ErrorHandler from '../../lib/error-handler';
import { LoadingModal } from '../loading-modal/loading-modal';
import { waitForClerk } from '../types/clerk-shim';

declare var Penmate;

@Component({
  selector: 'pm-clerk-login-modal',
  templateUrl: 'clerk-login-modal.html',
  styleUrls: ['./clerk-login-modal.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClerkLoginModal implements AfterViewInit, OnDestroy {
  loading = false;
  clerkInstance: any;
  
  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    public modalCtrl: ModalController,
    private authService: AuthService,
    private maintenanceService: MaintenanceService,
  ) {}

  async ngAfterViewInit() {
    try {
      this.maintenanceService.setMaintenanceModalOverride(true);
      this.maintenanceService.refreshStatus().subscribe(() => {}, () => {});
      this.loading = true;
      // Wait for Clerk to be available from CDN (already initialized)
      this.clerkInstance = await waitForClerk();
      
      // Mount the Clerk sign-in UI
      const signInDiv = document.getElementById('clerk-signin');
      if (signInDiv) {
        // mountSignIn returns a promise that resolves when mounted
        await this.clerkInstance.mountSignIn(signInDiv, {
          fallbackRedirectUrl: `${Penmate.env.rootUrl}/login`,
          signUpUrl: `${Penmate.env.rootUrl}/signup`,
          signUpForceRedirectUrl: `${Penmate.env.rootUrl}/signin`,
          signUpFallbackRedirectUrl: `${Penmate.env.rootUrl}/signin`,
          withSignUp: false,
        });
        
        // Set loading to false after mount completes
        this.loading = false;
        
        // Listen for successful sign-in
        this.clerkInstance.addListener(this.handleClerkAuth);
      } else {
        // No div found, stop loading
        this.loading = false;
        console.error('Clerk sign-in div not found');
      }
    } catch (error) {
      this.loading = false;
      ErrorHandler.captureException(error, 'Clerk initialization error');
      console.error('Failed to initialize Clerk:', error);
    }
  }

  handleClerkAuth = async (emission: any) => {
    if (!emission.user) return;
    
    try {
      // this.loading = true;
      // const loadingModal = await this.modalCtrl.create({
      //   component: LoadingModal,
      //   componentProps: { message: 'Signing in...' },
      // });
      // await loadingModal.present();
      
      // Get the current session
      const session = emission.session || this.clerkInstance.session;
      console.log("@@@ session", session);
      // if (!session) {
      //   await loadingModal.dismiss();
      //   this.loading = false;
      //   return;
      // }
      
      // // Send session ID to backend for authentication
      // this.authService.apiClient.post(
      //   `${Penmate.env.apiUrl}/login?type=web`,
      //   {},
      //   { clerk: session.id }
      // ).subscribe(
      //   async (data) => {
      //     // Store auth token
      //     await this.storage.set('id_token', data.auth_token);
      //     await this.storage.set('user', data.user);
          
      //     // Store Clerk sign-in token if provided
      //     if (data.sign_in_token) {
      //       await this.storage.set('clerk_sign_in_token', data.sign_in_token);
      //     }
          
      //     await loadingModal.dismiss();
      //     this.loading = false;
          
      //     // Handle navigation after successful login
      //     this.authService.handleLoginNavigation(this.navCtrl).subscribe(() => {
      //       this.modalCtrl.getTop().then(modal => {
      //         if (modal) {
      //           modal.dismiss();
      //         }
      //       });
      //     });
      //   },
      //   async (error) => {
      //     await loadingModal.dismiss();
      //     this.loading = false;
      //     ErrorHandler.captureMessage('Login Error: Clerk', { error });
      //     console.error('Login error:', error);
      //   }
      // );
    } catch (error) {
      this.loading = false;
      ErrorHandler.captureException(error, 'Clerk auth handling error');
    }
  };

  ngOnDestroy() {
    // Clean up Clerk listeners
    if (this.clerkInstance) {
      this.clerkInstance.removeListener(this.handleClerkAuth);
      this.clerkInstance.unmountSignIn('#clerk-signin');
    }
    this.maintenanceService.setMaintenanceModalOverride(false);
  }

  cancel() {
    this.maintenanceService.setMaintenanceModalOverride(false);
    this.modalCtrl.dismiss();
  }
}
